/* import __COLOCATED_TEMPLATE__ from './conversation-filter.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';

interface Signature {
  Args: {
    selectedValue?: string;
    filterContent: (filterKey: string, value: string) => void;
  };
}

export default class ConversationFilter extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked inputValue = '';

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    this.inputValue = this.args.selectedValue === 'any' ? '' : this.args.selectedValue || '';
  }

  get details(): string {
    if (this.inputValue) {
      return this.intl.t('workflow-connector.builder.logs.filter.conversation.with-id', {
        conversationId: this.inputValue,
      });
    } else {
      return this.intl.t('workflow-connector.builder.logs.filter.conversation.any');
    }
  }

  @action resetSelectedValue(_element: Element, [selectedValue]: [string]): void {
    this.inputValue = selectedValue === 'any' ? '' : selectedValue || '';
  }

  @action onInputChange(event: Event): void {
    let target = event.target as HTMLInputElement;
    this.inputValue = target.value;
    // Immediately update the filter as user types
    this.args.filterContent('conversation_id', this.inputValue || 'any');
  }

  @action onClear(): void {
    this.inputValue = '';
    this.args.filterContent('conversation_id', 'any');
  }

  @action onClose(): void {
    // Called when dropdown closes - no specific action needed
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::Builder::Logs::Filters::ConversationFilter': typeof ConversationFilter;
    'workflow-connector/builder/logs/filters/conversation-filter': typeof ConversationFilter;
  }
}
